import React, { useState, useEffect, useRef, useContext } from 'react'
import _ from 'lodash'
import cx from 'classnames'

import { AutoGrowLayout } from '../autoGrowLayout'
import { WidgetsContext } from '../core'
import { QuestionDesign } from './questionDesign'

import { getColorsConfig } from '../../../components/AssetViewer/helper/cssHelper'

import styles from './seekContainer.module.scss'

const SeekWidgetComponent = ({
  className,
  style,
  widgetProps,
  breakpoint,
  ...rest
}) => {
  const context = useContext(WidgetsContext)
  const seekContainerRef = useRef(null)
  const id = _.get(widgetProps, 'uid')
  const type = _.get(widgetProps, 'type')
  const stretched = _.get(widgetProps, 'properties.desktop.stretched', false)
  const questionDesign = _.get(
    widgetProps,
    `properties.${breakpoint}.questionDesign`,
    {}
  )
  const seekLayoutType = _.get(questionDesign, `type`, 'bar')

  var widgetStyle = {
    ...style,
    ...getStyles(widgetProps, breakpoint, seekLayoutType)
  }
  
  return (
    <AutoGrowLayout
      ref={seekContainerRef}
      editorSession={context.session}
      breakpoint={breakpoint}
      widget={widgetProps}
    >
      <div
        className={cx(className, styles.seekContainer, {
          [styles.stretched]: stretched,
          [styles.mobile]: breakpoint === 'mobile'
        })}
        ref={seekContainerRef}
        style={widgetStyle}
        data-widget-id={id}
        data-widget-type={type}
      >
        <QuestionDesign
          widgetProps={widgetProps}
          breakpoint={breakpoint}
          className={styles.questionWrapper}
        />
      </div>
    </AutoGrowLayout>
  )
}

function getStyles(widgetProps, breakpoint, type) {
  const defaultProperties = _.get(widgetProps, `properties.desktop`)
  const deviceProperties = _.get(widgetProps, `properties.${breakpoint}`)

  const stretched = _.get(defaultProperties, 'stretched', false)
  const margin = _.get(defaultProperties, 'margin', 0)
  const padding = _.get(deviceProperties, `padding`, 0)
  var widgetStyles = {}

  if (breakpoint === 'desktop') {
    widgetStyles = {
      ...widgetStyles,
      width: `1200px`,
      paddingLeft: `0px`,
      marginLeft: `calc((100% - 1200px) * 0.5)`,
      paddingRight: `0px`
    }

    if (stretched) {
      widgetStyles = {
        ...widgetStyles,
        marginLeft: margin,
        width: `calc(100% - 2 * ${margin}px)`,
        left: `calc((100% - 2 * ${margin}px))/2)`
      }
    }
  }

  if (breakpoint === 'mobile') {
    widgetStyles = {
      ...widgetStyles,
      paddingLeft: `0px`,
      paddingRight: `0px`
    }
  }
  return widgetStyles
}

const seekWidgetEquals = function (prevProps, nextProps) {
  const paths = ['className', 'style', 'widgetProps', 'breakpoint']
  const next = _.pick(nextProps, paths)
  const previous = _.pick(prevProps, paths)

  const equals = _.isEqual(next, previous)
  return equals
}

export const SeekWidget = React.memo(SeekWidgetComponent, seekWidgetEquals)
